import { Button, Card, Layout } from "@shopify/polaris";
import { APP_EMBED_DEEPLINK } from "../constants/constants";

const AppEmbedDeepLink = (props: any) => {

  const shopData = JSON.parse(localStorage.getItem('shop') || '{}');
  let deepLink = APP_EMBED_DEEPLINK.embed_url.replace('<myshopifyDomain>', shopData.url);
  
  return (
    <Layout.Section>
          <Card sectioned>
            <div className="embedLink">
            <span className="embedNote">
                {APP_EMBED_DEEPLINK.note}
            </span>
            <span className="embedContent">
                {APP_EMBED_DEEPLINK.content[0]} {props.source} {APP_EMBED_DEEPLINK.content[1]}
            </span>
            <span className="embedPreview">
                <a href={APP_EMBED_DEEPLINK.preview_link} target="_blank"> 
                    {APP_EMBED_DEEPLINK.preview_text}
                </a>
            </span>
            </div>
            <div className="embedButton">
                <Button primary url={deepLink} external>
                    {APP_EMBED_DEEPLINK.embed_text}
                </Button>
            </div>
          </Card>
    </Layout.Section>
  );
};

export default AppEmbedDeepLink;
